import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDialogMessage } from '../dialog-message/dialog.message.interface';

@Component({
  selector: 'app-dialog-confirm-save',
  templateUrl: './dialog-confirm-save.component.html',
  styleUrls: ['./dialog-confirm-save.component.scss']
})
export class DialogConfirmSaveComponent {

  constructor( public dialog: MatDialogRef<DialogConfirmSaveComponent>, @Inject(MAT_DIALOG_DATA) public content: IDialogMessage) {
  }

  noResponse() {
    this.dialog.close(false);
  }

  yesResponse() {
    this.dialog.close(true);
  }

}
